<div class="qr-scanner-host w-100">
  <ngx-scanner-qrcode
    [symbolType]="qrSymbolTypes"
    [loadWasmUrl]="wasmUrl"
    [isBeep]="isBeep"
    (event)="onNgxEvent($event)"
  />
</div>
